import { INewFDInsertObj } from "../types/f-d-s-d-p-deposit-summary-types.types";
import { API_PATHS } from "../constants/api-paths";
import { createCacheAsync } from "@repo/shared-utils/cache";
import { IResponse, encryptedRequest } from "../core/api.client";

interface IFDSDPDetails {
  custId: string;
  totDepositAmt: string;
  totIntEarned: string;
  totSdpAmt: string;
  totFdAmt: string;
}

export interface ILatestFDDetails {
  interestRate: number;
  relAmount: number;
  depositId: string;
  maturityDate: string;
  interestStartDate: string;
  relStatus: string;
  prodId: string;
  prodDesc: string;
  prodCategory: string;
  tdsWaveOffFlag: boolean | null;
  daysToMature: number;
  hstFlag: boolean;
  applId: string;
  maturityAmount: number;
  srlNum: string;
  interestAmount: number;
  renewFlag: string;
}

export const getFDSDPDetails = async (data: {
  mobileNo: string;
  customerId: string;
}): Promise<IResponse<IFDSDPDetails>> => {
  try {
    const response = await encryptedRequest<IFDSDPDetails>({
      method: "POST",
      url: API_PATHS.fdsdpDetails,
      data: {
        ...data,
      },
    });

    if (response.statusCode !== 90) throw response.message;

    return response;
  } catch (error) {
    // this can be replaced once new relic implemented
    console.error(error);
    throw error;
  }
};

export const insertFDSDPDetails = async (
  data: INewFDInsertObj
): Promise<IResponse<INewFDInsertObj>> => {
  try {
    const response = await encryptedRequest<INewFDInsertObj>({
      method: "POST",
      url: API_PATHS.fdsdpInsert,
      data: {
        ...data,
      },
    });

    if (response.statusCode !== 90) {
      // Return error response instead of throwing - let caller handle UI state
      return response;
    }
    return response;
  } catch (error) {
    // this can be replaced once new relic implemented
    console.error(error);
    throw error;
  }
};

const getLatestFDSDPDetailsAPI = async (data: {
  mobileNo: string;
  customerId: string;
}): Promise<ILatestFDDetails> => {
  try {
    const response = await encryptedRequest<ILatestFDDetails>({
      method: "POST",
      url: API_PATHS.latestfdsdpDetails,
      data: {
        ...data,
      },
    });

    if (response.status === "error") throw response.message;

    return response.data;
  } catch (error) {
    // this can be replaced once new relic implemented
    console.error(error);
    throw error;
  }
};

export const getLatestFDSDPDetails = async (data: {
  mobileNo: string;
  customerId: string;
  productCategory: string;
}): Promise<ILatestFDDetails> => {
  const response = await createCacheAsync(
    `${API_PATHS.latestfdsdpDetails}-${data.mobileNo}`,
    getLatestFDSDPDetailsAPI,
    data
  );
  return response;
};
